define('plugin/membership/view/MembershipSelectListView',['require','lib/view/LayoutView','lib/view/UnwrapBehavior'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Membership select list view
     *
     * @class MembershipSelectListView
     */
    return LayoutView.extend({

        template: '#membership_select_list_view',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        ui: {
            'select': '#sb_membership_select'
        },
        events: {
            'change @ui.select': '_onChange'
        },
        collection: null,
        bookingModel: null,

        initialize: function () {
            this.collection = this.getOption('collection');
            this.bookingModel = this.getOption('bookingModel');

            this.listenTo(this.collection, 'sync', this.renderSafe);
            this.listenTo(this.bookingModel, 'change:service', this.renderSafe);
        },

        renderSafe: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        _onChange: function () {
            this.triggerMethod('change:membership', this.ui.select.val());
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.apply(this), {
                items: this.collection.toJSON(),
                service_id: this.bookingModel.get('service_id'),
                error: this.getOption('error'),
                display: this.bookingModel.get('service') && this.bookingModel.get('service').memberships
            });
        }

    });

});
